export default "__VITE_ASSET__DY1Mpf8J__";